import { render, staticRenderFns } from "./BlogPostsContainer.vue?vue&type=template&id=e11efb28"
import script from "./BlogPostsContainer.vue?vue&type=script&lang=ts"
export * from "./BlogPostsContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports